import { FC, useState } from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import AccountInfo from './components/AccountInfo';
import Personalization from './components/Personalization/Personalization';
import PassSettings from './components/PassSettings';
import Subscription from './components/Subscription';
import EmergencyContacts from './components/EmergencyContacts';
import TravelBuddies from './components/TravelBuddies';
import { useAppSelector } from '../../../hooks/redux';

import styles from './Profile.module.scss';

const Profile: FC = () => {
  const [selected, setSelected] = useState('personal-info');
  const { type: planType } = useAppSelector((state) => state.plan);

  const handleToggleChange = (_: React.MouseEvent<HTMLElement>, newSelection: string | null) => {
    if (newSelection !== null) setSelected(newSelection);
  };

  return (
    <Box className={styles.personalInfo}>
      <Typography variant='h4Bold'>Profile</Typography>
      <ToggleButtonGroup
        value={selected}
        exclusive
        onChange={handleToggleChange}
        className={styles.toggleGroup}
      >
        <ToggleButton value="personal-info" className={`${selected === 'personal-info' && styles.selected} ${styles.toggleButton}`}>
          {selected === 'personal-info' ? (
            <Typography variant='h11Bold'>Personal info</Typography>
          ) : (
            <Typography variant='h11Semibold'>Personal info</Typography>
          )}
        </ToggleButton>
        <ToggleButton value="contacts" className={`${selected === 'contacts' && styles.selected} ${styles.toggleButton}`}>
          {selected === 'contacts' ? (
            <Typography variant='h11Bold'>Contacts</Typography>
          ) : (
            <Typography variant='h11Semibold'>Contacts</Typography>
          )}
        </ToggleButton>
        <ToggleButton value="settings" className={`${selected === 'settings' && styles.selected} ${styles.toggleButton}`}>
          {selected === 'settings' ? (
            <Typography variant='h11Bold'>Settings</Typography>
          ) : (
            <Typography variant='h11Semibold'>Settings</Typography>
          )}
        </ToggleButton>
        <ToggleButton value="subscription" className={`${selected === 'subscription' && styles.selected} ${styles.toggleButton}`}>
          {selected === 'subscription' ? (
            <Typography variant='h11Bold'>Plans</Typography>
          ) : (
            <Typography variant='h11Semibold'>Plans</Typography>
          )}
        </ToggleButton>
      </ToggleButtonGroup>

      {selected === 'personal-info' && (
        <Box className={styles.contentWrapper}>
          <Box className={styles.content}>
            <AccountInfo />
            <Personalization />
          </Box>
        </Box>
      )}

      {selected === 'contacts' && (
        <Box className={styles.contentWrapper}>
          <Box className={styles.content}>
            <EmergencyContacts />
            <TravelBuddies />
          </Box>
          <Box className={`${styles.fullAccessLabel} ${planType.includes('basic') || !planType.length ? '' : styles.fullAccessLabelHide}`} onClick={() => setSelected('subscription')}>
            <Box className={styles.fullAccessTextContent}>
              <Typography variant='h8Bold'>Would you like more options?</Typography>
              <Typography variant='h11'>To get full access, upgrade your plan</Typography>
            </Box>
            <Typography variant='h10Bold' className={styles.fullAccessBtn}>Get full access</Typography>
          </Box>
        </Box>
      )}

      {selected === 'settings' && (
        <Box className={styles.contentWrapper}>
          <Box className={styles.content}>
            <PassSettings />
          </Box>
        </Box>
      )}

      {selected === 'subscription' && (
        <Box className={styles.contentWrapper}>
          <Box className={styles.content}>
            <Subscription />
          </Box>
        </Box>
      )}

    </Box>
  )
}

export default Profile;
